import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Avatar, Typography, Chip } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import ChatIcon from '@mui/icons-material/Chat';
import { ZapyIcon } from '../../../../components/icons/ZapyIcon';
import { ChannelType, type Channel } from '../../../../types/chat.types';

const ChannelIcon = ({ type, size = 'medium' }: { type: ChannelType; size?: 'small' | 'medium' | 'large' }) => {
  const fontSize = size === 'large' ? 40 : size === 'medium' ? 24 : 16;

  switch (type) {
    case ChannelType.ZAPY:
      return <ZapyIcon fontSize={fontSize} />;
    case ChannelType.TELEGRAM:
      return <TelegramIcon sx={{ fontSize }} color="info" />;
    default:
      return <ChatIcon sx={{ fontSize }} />;
  }
};

export const ChannelHeader = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();
  if (!record) return null;

  return (
    <Box display="flex" alignItems="center" gap={2} mb={3}>
      <Avatar sx={{ width: 64, height: 64, bgcolor: 'action.hover' }}>
        <ChannelIcon type={record.type} size="large" />
      </Avatar>
      <Box>
        <Typography variant="h5">{record.name}</Typography>
        <Box display="flex" gap={1} mt={1}>
          <Chip
            label={translate(`resources.channel.types.${record.type}`)}
            size="small"
            variant="outlined"
          />
        </Box>
      </Box>
    </Box>
  );
};
